module.exports = __webpack_public_path__ + "static/Education-d065b181dd306110363807c69a49fecc.png";